













































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import FaqBox from '@/components/FaqBox.vue';
import ScrollArea from '@/pages/P0918/ScrollArea.vue';

@Component({
  components: { FaqBox, ScrollArea }
})
export default class P0927 extends Vue {
  activeTabName = 'coupon';
  isOpenCoupon01 = false;
  isOpenCoupon02 = false;
}
